module.exports = __webpack_public_path__ + "img/card-paypal.1db80f14.svg";